<template>
  <div>
    <span style="width: 100%; height: 100%" @click="OpenDialog">
      <span class="passward" type="info">修改密码</span>
    </span>

    <el-dialog title="更改密码" width="400px" :visible.sync="dialogVisible" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
      <template slot="title">
        <h2 style="text-align:center; font-size:18px;font-weight:bold;">更改密码</h2>
      </template>
      <el-form :model="resetForm" :rules="dynamicRules" ref="resetForm" status-icon size="mini">
        <el-form-item label="当前密码" prop="oldPassword">
          <el-input type="password" show-password v-model.trim="resetForm.oldPassword" placeholder="请输入当前密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword1">
          <el-input type="password" show-password v-model.trim="resetForm.newPassword1" placeholder="请输入新密码"></el-input>
          <span style="padding-left:10px;font-size:12px;color:#999;">{{$store.state.user.identity === 1?'密码长度为8~16个字符':'至少8个字符长度'}}，数字+字母{{$store.state.user.identity === 1?'+符号':''}}</span>
        </el-form-item>
        <el-form-item label="重新输入新密码" prop="newPassword2">
          <el-input type="password" show-password v-model.trim="resetForm.newPassword2" placeholder="请再次输入新密码"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <!-- <el-button type="primary" @click.prevent="toAmend" size="small">确认修改</el-button>
        <el-button @click="quitDialog('form')" size="small">关 闭</el-button> -->
        <el-button @click="quitDialog('form')" size="small">取 消</el-button>
        <el-button type="primary" @click="toAmend" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  stuUpdateStudentPassword,
  // tchUpdateUserPassword,
} from '@/api/educational'
import { api_tchPersonalColumnUpdatePassword } from '@/api/javaApi'
import CryptoJS from 'crypto-js'

export default {
  name: 'passward',
  data() {
    var validatePass = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入新密码'))
      } else if (value.toString().length < 6 || value.toString().length > 18) {
        callback(new Error('密码长度为6-18位'))
      } else {
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.resetForm.newPassword1) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      resetForm: {
        //传给后台所需要的参数
        oldPassword: '',
        newPassword1: '',
        newPassword2: '',
      },
      resetFormRules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' },
        ],
        newPassword1: [{ required: true, validator: validatePass, trigger: 'blur' }],
        newPassword2: [
          { required: true, validator: validatePass2, trigger: 'blur' },
        ],
      },
      dialogVisible: false,
    }
  },
  computed: {
    dynamicRules() {
      const identity = this.$store.state.user.identity;
      const pattern = identity === 1
        ? /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()\-+={}[\]:;'<>,.?/~_\\|]).{8,16}$/
        : /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;
      const characterRequirement = identity === 1
        ? '密码长度为8~16个字符，必须包含至少一个字母、一个数字和一个特殊符号'
        : '密码至少8个字符长度，必须包含至少一个字母和一个数字';
      return {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        newPassword1: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { pattern, message: characterRequirement, trigger: 'blur' }
        ],
        newPassword2: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: this.validateConfirmPassword, trigger: 'blur' }
        ]
      };
    },
    passwordLengthRequirement() {
      return `至少${this.dynamicRules.newPassword1[1].min}个字符`;
    },
    passwordCharacterRequirement() {
      return this.dynamicRules.newPassword1[2].message;
    },
  },
  methods: {
    toAmend() {
      this.$refs.resetForm.validate((valid) => {
        if (valid) {
          //这里的api.materialQuery.toAmend是调用前期我们统一的api接口url路径，不作参考 ，只要把后台需要的字段正常传进去即可
          if (this.resetForm.newPassword1 !== this.resetForm.newPassword2) {
            return this.$message.error('两次密码输入不一致');
          }
          if (this.$store.state.user.identity === 2) {
            stuUpdateStudentPassword({
              oldPassword: CryptoJS.MD5(this.resetForm.oldPassword).toString(
                CryptoJS.enc.Base64
              ),
              newPassword: CryptoJS.MD5(this.resetForm.newPassword1).toString(
                CryptoJS.enc.Base64
              ),
            }).then((res) => {
              console.log('修改密码')
              console.log(res)
              this.$message.success('密码重置成功,请重新登录')
              this.dialogVisible = false
              this.$store.dispatch('LogOut').then(() => {
                this.$router.push({ path: '/login' })
              })
            })
          } else {
            api_tchPersonalColumnUpdatePassword({
              oldPassword: CryptoJS.MD5(this.resetForm.oldPassword).toString(
                CryptoJS.enc.Base64
              ),
              newPassword: CryptoJS.MD5(this.resetForm.newPassword1).toString(
                CryptoJS.enc.Base64
              ),
            }).then((res) => {
              console.log('修改密码')
              console.log(res)
              if (res && res.error) {
                this.$message.error(res.error.message)
              } else {
                // if (res.is_update) {
                this.$message.success('密码重置成功,请重新登录')
                this.dialogVisible = false
                this.$store.dispatch('LogOut').then(() => {
                  this.$router.push({ path: '/login' })
                })
                // }
              }
            })
          }
        }
      })
    },

    OpenDialog() {
      console.log('修改密码')
      this.dialogVisible = true
    },

    quitDialog() {
      this.$refs['resetForm'].resetFields()
      this.dialogVisible = false
    },
  },
}
</script>

<style scoped lang="scss">
.passward {
  color: #606166;
}

.passward:hover {
  color: #67b1ff;
}
</style>
